import { useLocaleState, useTranslate } from "ra-core";
import { Button } from "@/components/ui/button";

// One-tap switch between English and Chinese. The choice is stored per browser by ra-core.
export const LanguageToggle = () => {
  const [locale, setLocale] = useLocaleState();
  const translate = useTranslate();
  return (
    <Button
      variant="ghost"
      size="sm"
      className="font-medium"
      aria-label={translate("egi.language.switch_label")}
      onClick={() => setLocale(locale === "zh" ? "en" : "zh")}
    >
      {translate("egi.language.switch")}
    </Button>
  );
};
